import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import { entries } from 'lodash'
import { connect } from 'react-redux'

import DateAxisTick from '../../components/resourcesChart/dateaxistick/DateAxisTick'
import ManningToolTip from '../../components/resourcesChart/manningtooltip/ManningToolTip'
import ProductLegend from '../../components/resourcesChart/productLegend/ProductLegend'
import { createResourcePlanningDataset } from '../../utils/terminalVisitManningUtils'
import './ResourcePlanning.scss'

const ResourcePlanning = props => {
  const formatYAxis = value => `${value} hrs`

  const { terminalVisits, dateRange, config } = props.app.present
  const resourcePlanningDataSet = createResourcePlanningDataset(terminalVisits, dateRange.from, dateRange.to, config)

  return (
    <div className="resource-page main">
      <div className="content-wrapper">
        <div className="content">
          <h2>Resource planning</h2>
          <ResponsiveContainer height={500}>
            <BarChart data={resourcePlanningDataSet}>
              <XAxis dataKey="shiftStart" interval={0} tick={<DateAxisTick />} height={120} />
              <YAxis tickFormatter={formatYAxis} />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip content={<ManningToolTip />} />
              <Legend content={<ProductLegend />} />
              {prepareBars(resourcePlanningDataSet)}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  )

  function prepareBars(resourcePlanning) {
    if (!resourcePlanning.length) {
      return null
    }
    const uniqueListOfUsedProducts = {}

    resourcePlanning
      .map(p => p.manningMap)
      .forEach(planning => {
        entries(planning).forEach(([key, value]) => {
          uniqueListOfUsedProducts[key] = value.color
        })
      })

    return entries(uniqueListOfUsedProducts).map(([key, value]) => {
      return (
        <Bar
          key={key}
          dataKey={`manningMap.${key}.manning`}
          name={key}
          stackId="a"
          fill={value}
          stroke="#fff"
          isAnimationActive={false}
        />
      )
    })
  }
}

ResourcePlanning.propTypes = {}

export default connect(state => state)(React.memo(ResourcePlanning))
